import React, { useEffect, useState } from "react";
import Joi from "joi-browser";
import { useDispatch, useSelector } from "react-redux";
import { 
  getEmailTemplates, 
  getLetterTemplates, 
  loadFormsByType 
} from "../app/store/template";
import Select from "../comman/select";
import TextArea from "../comman/textarea";

const TemplatePopup = ({ handleSubmit, selectedTemplate, onClose, isLoading }) => {
  const dispatch = useDispatch();
  
  const emailTemplates = useSelector(getEmailTemplates) || [];
  const letterTemplates = useSelector(getLetterTemplates) || [];
  
  const [data, setData] = useState({
    templateType: "",
    templateId: "",
    notes: ""
  });
  
  const [errors, setErrors] = useState({});

  const TemplateTypes = [
    { id: "Email", name: "Email Template" }, 
    { id: "Letter", name: "Letter Template" }
  ];

  const schema = {
    templateType: Joi.string().required().label("Template Type"),
    templateId: Joi.string().required().label("Template"),
    notes: Joi.string().required().label("Notes"),
  };

  useEffect(() => {
    dispatch(loadFormsByType("EmailTemplate"));
    dispatch(loadFormsByType("LetterTemplate"));
  }, [dispatch]);

  useEffect(() => {
    if (selectedTemplate) {
      setData(selectedTemplate);
    } else {
      setData({
        templateType: "",
        templateId: "",
        notes: ""
      });
    }
  }, [selectedTemplate]);

  const validateProperty = ({ name, value }) => {
    const obj = { [name]: value };
    const subSchema = { [name]: schema[name] };
    const { error } = Joi.validate(obj, subSchema);
    return error ? error.details[0].message : null;
  };

  const handleChange = ({ currentTarget: input }) => {
    const newErrors = { ...errors };
    const errorMessage = validateProperty(input);
    if (errorMessage) newErrors[input.name] = errorMessage;
    else delete newErrors[input.name];

    const newData = { ...data };
    newData[input.name] = input.value;
    
    // Reset templateId if type changes
    if (input.name === "templateType") {
      newData.templateId = "";
    }

    setData(newData);
    setErrors(newErrors);
  };

  const validate = () => {
    const options = { abortEarly: false };
    const { error } = Joi.validate(data, schema, options);
    if (!error) return null;

    const newErrors = {};
    for (let item of error.details) newErrors[item.path[0]] = item.message;
    return newErrors;
  };

  const onSubmit = (e) => {
    if (e) e.preventDefault();
    const newErrors = validate();
    setErrors(newErrors || {});
    if (newErrors) return;

    const finalData = { ...data };
    const templates = data.templateType === "Letter" ? letterTemplates : emailTemplates;
    const selectedItem = templates.find(x => x.id === parseInt(data.templateId));
    
    if (selectedItem) {
      finalData.templateName = selectedItem.formTitle;
    }
    
    handleSubmit(finalData);
  };

  const isInvalid = validate() !== null;

    const richUiStyles = `
    .template-popup-container {
      background: #ffffff;
      padding: 20px 24px;
      border: 1px solid #cbd5e1;
      border-radius: 0 !important;
      color: #1e293b;
      font-family: 'Inter', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
      box-shadow: none !important;
    }

    .form-section {
      margin-bottom: 20px;
    }

    .modern-label {
      font-size: 12px !important;
      font-weight: 700 !important;
      color: #334155 !important;
      margin-bottom: 6px !important;
      display: block !important;
      text-transform: uppercase !important;
      letter-spacing: 0.04em !important;
    }

    .template-popup-container .form-control {
      border: 1px solid #cbd5e1 !important;
      border-radius: 0 !important;
      font-size: 13.5px !important;
      padding: 8px 12px !important;
      height: auto !important;
      color: #1e293b !important;
      background-color: #ffffff !important;
      box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04) !important;
      transition: all 0.2s ease !important;
    }

    .template-popup-container .form-control:focus {
      border-color: #2563eb !important;
      box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.12) !important;
      background-color: #ffffff !important;
    }

    .template-popup-container textarea.form-control {
      min-height: 100px !important;
      resize: vertical !important;
    }

    .wf-popup-footer {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 12px;
      margin-top: 24px;
      padding-top: 20px;
      border-top: 1px solid #e2e8f0;
    }

    .wf-btn {
      display: inline-flex !important;
      align-items: center !important;
      justify-content: center !important;
      gap: 8px !important;
      padding: 7px 18px !important;
      font-size: 13.5px !important;
      font-weight: 500 !important;
      border-radius: 0 !important;
      cursor: pointer !important;
      transition: all 0.2s ease !important;
      outline: none !important;
      min-width: 120px !important;
      box-shadow: 0 2px 5px rgba(15, 23, 42, 0.06) !important;
    }

    .wf-btn:disabled {
      opacity: 0.85 !important;
      cursor: not-allowed !important;
      background: #cbd5e1 !important;
      border-color: #cbd5e1 !important;
      color: #94a3b8 !important;
      box-shadow: none !important;
      transform: none !important;
    }

    .wf-btn-primary {
      background: #2563eb !important;
      color: #ffffff !important;
      border: 1px solid #2563eb !important;
      box-shadow: 0 2px 5px rgba(37, 99, 235, 0.2) !important;
    }

    .wf-btn-primary:hover:not(:disabled) {
      background: #1d4ed8 !important;
      border-color: #1d4ed8 !important;
      transform: translateY(-1px) !important;
      box-shadow: 0 4px 12px rgba(37, 99, 235, 0.3) !important;
    }

    .wf-btn-secondary {
      background: #ffffff !important;
      color: #1e293b !important;
      border: 1px solid #cbd5e1 !important;
    }

    .wf-btn-secondary:hover:not(:disabled) {
      background: #f8fafc !important;
      color: #0f172a !important;
      border-color: #94a3b8 !important;
      transform: translateY(-1px) !important;
    }
  `;

  return (
    <div className="template-popup-container">
      <style>{richUiStyles}</style>
      <form onSubmit={onSubmit}>
        <div className="row">
          <div className="col-md-12 form-section">
            <label className="modern-label">Template Type</label>
            <Select
              name="templateType"
              value={data.templateType}
              options={TemplateTypes}
              onChange={handleChange}
              error={errors.templateType}
              optName="name"
              optValue="id"
              placeholder="Select Template Type"
            />
          </div>

          {data.templateType && (
            <div className="col-md-12 form-section">
              <label className="modern-label">Select {data.templateType} Template</label>
              <Select
                name="templateId"
                value={data.templateId}
                options={data.templateType === "Letter" ? letterTemplates : emailTemplates}
                onChange={handleChange}
                error={errors.templateId}
                optName="formTitle"
                optValue="id"
                placeholder={`Choose ${data.templateType.toLowerCase()} template...`}
              />
            </div>
          )}

          <div className="col-lg-12 form-section">
            <label className="modern-label">Additional Notes</label>
            <TextArea
              name="notes"
              value={data.notes}
              onChange={handleChange}
              error={errors.notes}
              placeholder="Enter any relevant notes here..."
            />
          </div>
        </div>

        <div className="wf-popup-footer">
          {onClose && (
            <button
              className="wf-btn wf-btn-secondary"
              onClick={onClose}
              type="button"
              disabled={isLoading}
            >
              <i className="fa fa-arrow-left" aria-hidden="true" />
              Back
            </button>
          )}
          <button 
            type="submit" 
            className="wf-btn wf-btn-primary"
            disabled={isLoading || isInvalid}
          >
            {isLoading ? (
              <>
                <i className="fa fa-spinner fa-spin" aria-hidden="true"></i>
                Saving...
              </>
            ) : (
              <>
                <i className="fa fa-check-circle" aria-hidden="true"></i>
                Save Template
              </>
            )}
          </button>
        </div>
      </form>
    </div>
  );
};

export default TemplatePopup;
